import { render, staticRenderFns } from "./SwipeList.vue?vue&type=template&id=340b39c2&"
import script from "./SwipeList.vue?vue&type=script&setup=true&lang=js&"
export * from "./SwipeList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports